import { Link } from "react-router-dom";

export const Footer = ({ site = {} }) => {
  const tagline = site.footer_tagline || "A collective of world builders, UGC designers and cinematographers shaping the next era of games.";
  const twitter = site.footer_twitter || "https://twitter.com";
  const youtube = site.footer_youtube || "https://youtube.com";
  const discord = site.footer_discord || "https://discord.gg/etoire";
  const copyright = site.footer_copyright || "© 2026 Etoire Studio";
  const credit = site.footer_credit || "Built for players, by creators";

  return (
    <footer data-testid="site-footer" className="border-t border-border mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div>
            <Link to="/" className="font-display font-black text-4xl tracking-tighter uppercase">
              Etoire<span className="text-volt">.</span>
            </Link>
            <p className="mt-4 max-w-sm text-muted-foreground text-sm leading-relaxed">
              {tagline}
            </p>
          </div>
          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="font-mono text-xs tracking-[0.2em] uppercase text-volt">Explore</span>
              <a href="/#creators" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">Creators</a>
              <a href="/#work" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">Work</a>
              <a href="/#manifesto" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">Manifesto</a>
            </div>
            <div className="flex flex-col gap-3">
              <span className="font-mono text-xs tracking-[0.2em] uppercase text-volt">Connect</span>
              <a href={twitter} target="_blank" rel="noreferrer" data-testid="footer-twitter" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">Twitter</a>
              <a href={youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">YouTube</a>
              <a href={discord} target="_blank" rel="noreferrer" data-testid="footer-discord" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">Discord</a>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-4">
          <span className="font-mono text-xs tracking-[0.15em] uppercase text-muted-foreground">{copyright}</span>
          <span className="font-mono text-xs tracking-[0.15em] uppercase text-muted-foreground">{credit}</span>
        </div>
      </div>
    </footer>
  );
};
